import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: '',
    section: {
        ids: [],
        entries: {}
    },
    column: {},
    component: {}
}

export const pageRenderSlice = createSlice({
  name: 'render',
  initialState,
  reducers: {
      updateRenderState: (state, action) => {
        Object.assign(state, {
            section: action.payload.section,
            column: action.payload.column,
            component: action.payload.component,
            name: action.payload.name
        })
      }
  },
})

// Action creators are generated for each case reducer function
export const { updateRenderState } = pageRenderSlice.actions

export default pageRenderSlice.reducer